<template>
  <!-- AI F §1.4.1, §1.4.2 — a live read of one page -->
  <div class="p-8">
    <woot-modal-header
      :header-title="$t('KNOWLEDGE_BASE.WEB_SEARCH.TITLE')"
      :header-content="$t('KNOWLEDGE_BASE.WEB_SEARCH.DESC')"
    />

    <form class="mt-4" @submit.prevent="submit">
      <label>
        <span class="flex justify-between items-baseline">
          {{ $t('KNOWLEDGE_BASE.WEB_SEARCH.ADDRESS') }}
          <span class="text-xs font-normal text-slate-500">
            {{ url.length }} / {{ maxUrlChars }}
          </span>
        </span>
        <textarea
          v-model="url"
          rows="2"
          :maxlength="maxUrlChars"
          placeholder="https://example.com/prices"
        />
      </label>

      <!-- AI F §1.4.4 generates the name from the host; an optional name overrides it, as for a website -->
      <label>
        {{ $t('KNOWLEDGE_BASE.WEB_SEARCH.NAME') }}
        <input v-model="name" type="text" />
      </label>

      <p class="text-xs text-slate-500 mb-4">
        {{ $t('KNOWLEDGE_BASE.WEB_SEARCH.TEMPORARY') }}
      </p>

      <div class="flex justify-end gap-2">
        <woot-button variant="clear" @click.prevent="$emit('close')">
          {{ $t('KNOWLEDGE_BASE.WEB_SEARCH.CANCEL') }}
        </woot-button>
        <woot-button
          type="submit"
          :is-loading="isSaving"
          :is-disabled="!url.trim() || isSaving"
        >
          {{ $t('KNOWLEDGE_BASE.WEB_SEARCH.SAVE') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';

// The 500 of §1.4.1 belonged to the query field
const MAX_URL_CHARS = 500;

export default {
  mixins: [alertMixin],
  data() {
    return { url: '', name: '', isSaving: false, maxUrlChars: MAX_URL_CHARS };
  },
  methods: {
    async submit() {
      this.isSaving = true;
      try {
        await this.$store.dispatch('kbSources/create', {
          source_type: 'web_search',
          name: this.name.trim(),
          settings: { url: this.url.trim() },
        });
        this.showAlert(this.$t('KNOWLEDGE_BASE.WEB_SEARCH.STARTED'));
        this.$emit('close');
      } catch (error) {
        this.showAlert(
          error?.response?.data?.error ||
            this.$t('KNOWLEDGE_BASE.WEB_SEARCH.ERROR')
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
